// Components==============
import indexActivities from 'actions/activity/index';
import indexPhases from 'actions/phase/index';
import indexReflection from 'actions/reflection/index';
import indexProjectGroup from 'actions/project-group/index';
import indexProject from 'actions/project/index';
import indexTheme from 'actions/theme/index';
import Layout from 'components/Layout/Layout';
import Container from 'components/UI/Container/Container';
import NoContent from 'components/UI/NoContent/NoContent';
import ReflectionCard from 'components/UI/ProjectCard/components/Card/ReflectionCard';
import Title from 'components/UI/Title/Title';
import { useRedux } from 'hooks/useRedux';
import { useThemesWithProject } from 'hooks/useThemesWithProject';
import { useTranslate } from 'hooks/useTranslate';
import Invite from 'pages/Workspace/MyProjects/Invite/Invite';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import './MyReflections.module.scss';
// =========================

export default function MyReflections() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(indexTheme());
    dispatch(indexProject());
    dispatch(indexProjectGroup());
    dispatch(indexActivities());
    dispatch(indexPhases());
    dispatch(indexReflection());
  }, []);

  const loading = useRedux(
    (state) =>
      state.theme?.loading ||
      state.project?.loading ||
      state.projectGroup?.loading ||
      state.activity?.loading ||
      state.phase?.loading
  );

  const userId = useRedux((state) => state.authentication?.user?.id);

  const themesWithProject = useThemesWithProject();

  const reflections = useRedux((state) =>
    themesWithProject.map((theme) => {
      const reflectionEntities = state.reflection?.entities.allIds
        .map((id) => state.reflection?.entities.byId[id])
        .filter((r) => !r?.for_user)
        .filter(
          (r) =>
            r?.created_by === userId &&
            r?.project_process?.project_id === theme?.project?.id
        );

      const endPointIsFinished = !!reflectionEntities?.find(
        (r) =>
          r?.project_process?.process_type === 'App\\Phase' &&
          r?.note?.find((qna) => !qna.answer) === undefined
      );

      const isFinished = endPointIsFinished;

      return { ...theme, isFinished };
    })
  );

  const translate = useTranslate();

  const invites = useRedux((state) =>
    state.reflection?.entities.allIds
      .map((id) => state.reflection?.entities.byId[id])
      ?.filter(
        (reflection) =>
          reflection?.user.id === userId &&
          !!reflection?.for_user &&
          !reflection?.finished &&
          // check if process still exists
          !!reflection?.project_process
      )
  );

  return (
    <Layout>
      <NoContent
        loading={!!loading}
        hasContent={!!(invites?.length || themesWithProject.length)}
        page="my-reflections"
      >
        <Container>
          <Title
            text={`reflection.terms.${
              invites?.length ? 'peer-reflections' : 'my-reflections'
            }`}
            loading={loading}
          />
          {!!invites?.length && (
            <div styleName="wrapper">
              {invites.map(
                (invite, i) =>
                  !!invite && (
                    <Invite key={i} reflection={invite} type="reflection" />
                  )
              )}
            </div>
          )}
          {!!invites?.length && (
            <h1 styleName="secondary-title">
              {translate('reflection.terms.my-reflections')}
            </h1>
          )}
          {!!reflections.filter((r) => !r.isFinished).length && (
            <div styleName="wrapper">
              {reflections
                .filter((r) => !r.isFinished)
                .map(
                  (theme) =>
                    !!theme.id && (
                      // @ts-ignore
                      <ReflectionCard key={theme?.id} theme={theme} />
                    )
                )}
            </div>
          )}
          {!!reflections.filter((r) => r.isFinished).length && (
            <>
              <h1 styleName="secondary-title">
                {translate('reflection.completed-reflections')}
              </h1>
              <div styleName="wrapper">
                {reflections
                  .filter((r) => r.isFinished)
                  .map(
                    (theme) =>
                      !!theme.id && (
                        // @ts-ignore
                        <ReflectionCard key={theme?.id} theme={theme} />
                      )
                  )}
              </div>
            </>
          )}
        </Container>
      </NoContent>
    </Layout>
  );
}
